import type { FC } from 'react'
import { useSnapshot } from 'valtio'
import { state, useRadarNav } from '../../lib/state'
import { CommonRadarSelector } from '../common/CommonRadarSelector'
import styles from './RadarHeader.module.css'

interface RadarHeaderProps {
  title?: string
}

export const RadarHeader: FC<RadarHeaderProps> = () => {
  const { availableRadars, isAdmin, context } = useSnapshot(state)
  const { radarId, route, routeRadar, rootRoute } = useRadarNav()
  const isDev = import.meta.env.DEV

  const currentRadar = availableRadars?.find(
    radar => Number(radar.id) === Number(radarId)
  )

  const displayTitle = currentRadar?.name || 'Tech Radar'

  // Debug logging for RadarHeader (only in development)
  if (isDev) {
    console.log('[RadarHeader] Rendering with:', {
      isAdmin,
      moduleKey: context?.moduleKey,
      localId: context?.localId,
      radarId,
      displayTitle
    })
  }
  return (
    <div className={styles.header}>
      <button
        className={styles.title}
        style={{
          cursor: 'pointer',
          background: 'none',
          border: 'none',
          padding: 0,
          marginLeft: isDev ? '16px' : '0px',
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: 1,
          textAlign: 'left',
          color: 'inherit'
        }}
        onClick={() => route('')}
        title="Home"
        type="button"
      >
        {displayTitle}
      </button>
      <div style={{ marginRight: isDev ? '16px' : '0px' }}>
        <CommonRadarSelector
          onSelectRadar={(radarId: number) => routeRadar(radarId)}
          onManageRadars={() => rootRoute('admin/radar-list')}
          showAdminOptions={isAdmin}
          buttonLabel={displayTitle}
        />
      </div>
    </div>
  )
}

export default RadarHeader
